import parseDimensions from "src/organization/pages/project/environment/metrics/utils/parseDimensions";
import {
  explodeMetrics,
  groupByTimestamp
} from "src/organization/pages/project/environment/metrics/utils/transformMetrics";

export const mergeHostTimestamp = data => {
  const point = {
    timestamp: new Date(data[0].timestamp)
  };

  for (const item of data) {
    const { value, name, hostname } = item;
    let key;
    switch (name) {
      case "max":
        key = "max";
        point[key] = Math.max(value, point[key] || 0);
        break;
      case "average.value":
        key = "average@value";
        break;
      case "average.percentage":
        key = "average@percentage";
        break;
      default:
        key = `${hostname}@${name}`;
        break;
    }
    point[key] = value;
  }
  return point;
};

function getMountpointsMap(serviceMetrics) {
  const mountpointGroups = serviceMetrics.reduce((acc, point) => {
    const mp = point.mountpoint;
    if (mp != null) {
      if (!acc[mp]) acc[mp] = [];
      acc[mp].push(point);
    }
    return acc;
  }, Object.create(null));

  return Object.keys(mountpointGroups)
    .sort((a, b) => a.localeCompare(b))
    .reduce((result, mp) => {
      const grouped = groupByTimestamp(mountpointGroups[mp]);
      if (grouped.length > 0) {
        result[mp] = grouped.map(mergeHostTimestamp);
      }
      return result;
    }, Object.create(null));
}

const getServiceMetrics = (serviceId, metrics) => {
  if (!metrics?.length || !serviceId) {
    return undefined;
  }
  const serviceMetrics = metrics.filter(point => point.service === serviceId);
  const mountpoints = getMountpointsMap(serviceMetrics);
  const cpu = groupByTimestamp(
    serviceMetrics.filter(point => point.type === "cpu")
  ).map(mergeHostTimestamp);

  const memory = groupByTimestamp(
    serviceMetrics.filter(point => point.type === "memory")
  ).map(mergeHostTimestamp);
  return {
    ...mountpoints,
    cpu,
    memory
  };
};

const build = (services?: any[], data?: any[]) => {
  const metrics = explodeMetrics(data);
  if (!services || !metrics) {
    return undefined;
  }

  return services.map(service => ({
    ...service,
    metrics: getServiceMetrics(service.name, metrics)
  }));
};

export const getDedicatedHost = (metrics?: any[]) => {
  if (!metrics) return [];
  const dimensions = metrics
    ?.map(d => parseDimensions(d.point?.dimension))
    .filter(v => v);
  const hosts = [
    "average",
    ...new Set(dimensions.map(d => d?.hostname).filter(Boolean))
  ] as string[];
  return hosts;
};

export default build;
